import { c as _c } from "react/compiler-runtime";
import { LayoutStack } from 'design-system/client';
import { useTranslations } from 'next-intl';
import styles from './CodonationBox.module.css';
import CodonationSelection from './CodonationSelection';
import I18nHtml from '@/components/I18nHtml';
function CodonationBox() {
  const $ = _c(9);
  const t = useTranslations("nextjs.donate.codonation_box");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <I18nHtml className={styles.heading} i18nKey="donate.codonation_box.heading_html" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("description");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <p>{t1}</p>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ul className={styles.box}><li><I18nHtml i18nKey="donate.codonation_box.details.item_1_html" /></li><li><I18nHtml i18nKey="donate.codonation_box.details.item_2_html" /></li><li><I18nHtml i18nKey="donate.codonation_box.details.item_3_html" /></li></ul>;
    t4 = <CodonationSelection />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2) {
    t5 = <LayoutStack className={styles.container} space="300">{t0}{t2}{t3}{t4}</LayoutStack>;
    $[7] = t2;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
export default CodonationBox;